import Space from "antd/lib/space";
import React, { memo } from "react";

import { LiveCasinoColorfulIcon, LiveCasinoIcon } from "@pages/casino/assets/icons";

const LiveCasinoTab = ({ translate }) => {
	const isColorful = window.CASINO_TABS_HAS_COLORFUL_ICONS;

	return (
		<Space>
			{isColorful ? <LiveCasinoColorfulIcon /> : <LiveCasinoIcon />}
			<span>{translate("casino.liveCasino")}</span>
		</Space>
	);
};

export default memo(LiveCasinoTab);
